import * as ko from "knockout";
import "./../../bindings/bao-pager";
function TagReportTabResultListViewModel(tabPage, tagReportModel) {
    var self = this;
    self.TabPage = tabPage;
    self.TagReportModel = tagReportModel;
    self.Sorting = self.TagReportModel.Sorting;
    self.PageSize = self.TagReportModel.PageSize;
    self.PageIndex = self.TagReportModel.PageIndex;
    self.TotalRows = self.TagReportModel.TotalRows;
    self.Models = self.TagReportModel.Models;
    self.Refresh = function () { };
}
;
export default TagReportTabResultListViewModel;